import React from 'react';
import { useTranslation } from 'react-i18next';
import './DataTable.css';

export interface ActionsColumnHeaderProps {
  /** Accessible name for the column header. */
  label?: string;
}

/** Visually hidden label for a table's row-actions column. */
export function ActionsColumnHeader({ label }: ActionsColumnHeaderProps) {
  const { t } = useTranslation();
  return (
    <span className="actions-column-header">
      {label ?? t('components.actionsColumnHeader.actions')}
    </span>
  );
}
